import { Card, CardBody, Col, CardHeader, Container, Form, FormGroup, Input, Label, Row, Table, Badge, Alert } from "reactstrap";
import { Btn, LI, P, UL, Image, Badges, H3, H5, SVG, H6, H4 } from "../../AbstractElements";
import { EdminLogin, SearchTableButton } from "../../utils/Constant";
import { generateRandomNumber, URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { calculateDaysRemaining, formatDate, formatPhoneNumber, formatPrice, itemHasPermission } from "../../utils/helper/helpers";
import SweetAlert from 'sweetalert2';
import { Link, useNavigate, useParams } from "react-router-dom";
// import { Chart } from "../BonDeCommande/apiBon";
import { dynamicImage } from "../../Service";
import repousserPaiement, { AddNumBons, AugmenterLeMontantPourCimaf, PayerVersement } from "../../utils/helper/modal";
import { deleteNumBon, deletePaiement, validerUnPaiment } from "./apiVersement";
import TableauShowLaffrage from './Tableau/laffrage';
import TableauShowDiamond from "./Tableau/diamond";
import TableauShowCimaf from "./Tableau/cimaf";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";

// Types
type Items = { [key: string]: any };


const ShowVersementsV2 = () => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [refresh, setRefresh] = useState(false);
    const [show, setShow] = useState(true);
    const [versements, setVersements] = useState<Items | null>(null);
    const [paiements, setPaiements] = useState<Items[]>([]);
    const [bons, setBons] = useState<Items[]>([]);
    const [identifyMat, setIdentifyMat] = useState<Items[]>([]);
    const params = useParams();
    // modal
    const [staticModal, setStaticModal] = useState(false); // modal 1
    const [modalAdd, setModalAdd] = useState(false); // modal 2
    const [modalPaiement, setModalPaiement] = useState(false); // modal 3
    const [modalAugmentMontantForCimaf, setModalAugmentMontantForCimaf] = useState(false); // modal 4
    // parametre modal
    const [paiementId, setPaiementId] = useState<number | undefined>(undefined);//id du paiement a effectuer
    const [montantPayed, setMontantPayed] = useState<number | undefined>(undefined);//montant du paiement a effectuer pour le dernier paiement
    const staticModalToggle = () => setStaticModal(!staticModal); // toggle modal 1
    const staticModalAddNumBonToggle = () => setModalAdd(!modalAdd);// toggle modal 2
    const staticModalPaiementToggle = () => setModalPaiement(!modalPaiement); // toggle modal 3
    const staticModalAugmenterMontantForCimafToggle = () => setModalAugmentMontantForCimaf(!setModalAugmentMontantForCimaf); // toggle modal 4

    const openModalWithRow = (id: number) => {
        setPaiementId(id);
        setStaticModal(true);
    };
    const openModalAddNumBons = () => {
        setModalAdd(true);
    };
    const openModalPaiement = (id: number, montant: number) => {
        setPaiementId(id);
        setMontantPayed(montant);
        setModalPaiement(true);
    }

    const openModalAugmenterMontantForCimaf = () => {
        setModalAugmentMontantForCimaf(true);
    }
    const pdfRef = useRef<HTMLDivElement>(null);

    // Fetch data from API
    const fetchVersements = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/versement/show/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                setVersements(response.data.versements);
                setPaiements(response.data.paiement);
                setIdentifyMat(response.data.identify_mat);
                setBons(response.data.bons)
            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    const Confirmation = ({ id, fournisseur, action }: { id: number, fournisseur: string | null, action: string | null }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir Supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                if(action === 'supprimerPaiement' && fournisseur){
                    deletePaiement({id: id, fournisseur: fournisseur }, () => setRefresh(!refresh));
                }
                if(action === 'supprimerNumBon' && !fournisseur){
                    deleteNumBon({ id: id }, () => setRefresh(!refresh));
                }
            }
        });
    };

    const downloadRecu = async (id: string, url: string) => {
        if (!id) {
            return;
        }

        try {
            const response = await axios.get(`${URL_API}/download-recu/${id}`, {
                headers: { Authorization: `Bearer ${Token}` },
                responseType: 'blob',
            });

            const fileUrl = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', "ReçuDePaiment" + url.split('/').pop() || 'document'); // Nom du fichier à télécharger
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            toast.info('Erreur lors du téléchargement du fichier');
        }
    };

    const handlePrint = useReactToPrint({
        content: () => pdfRef.current,
    });

    const onPrint = () => {
        setShow(false); // Masquer le contenu
        setTimeout(() => {
            handlePrint(); // Appeler la fonction d'impression
            setShow(true); // Réafficher après un délai
        }, 100); // Assurez-vous que le DOM a le temps de se mettre à jour
    };

    // const handlePrint = 
    const generatePDF = () => {
        setShow(false)
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`synthese_caisse${name_document}.pdf`)
                .then(() => setShow(true))
                .catch(() => setShow(true));
        }
    };

    // Initial data fetch
    useEffect(() => {
        fetchVersements();
    }, [refresh, fetchVersements]);

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Versements Details" parent="Versements" />
            <Container fluid>

                    <Card>
                        <CardBody>
                <div ref={pdfRef}>

                            <div className="text-center my-auto py-5">
                                <h1 className="text-uppercase fw-bold">{versements?.four_name}</h1>
                                <p className="f-20">{versements?.four_address}</p>
                                <p className="f-18">{formatPhoneNumber(versements?.four_phone)}</p>
                            </div>

                            <Row className="mx-3 my-4">
                                <Col lg={6} className="text-start text-uppercase">
                                    <p className="f-17"><span className="fw-bold">Nom du client </span> : {versements?.ets_name}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "92px" }}>Code </span>: {versements?.ets_code}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "110px" }}>Tel </span>: {formatPhoneNumber(versements?.ets_phone)}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "64px" }}>Adresse </span>: {versements?.ets_adresse}</p>
                                </Col>
                                {
                                    versements?.status === 'Payé' ? (
                                        <Col lg={6} className="text-end">

                                            <p className="f-17">Status: <Badges color="light-success">Payé</Badges></p>
                                            <p className="f-17">No Paiement: <span className="text-uppercase fw-bold">{versements?.pv_num_paiement}</span></p>
                                            <p className="f-17">Date de paiement: <span className="text-uppercase fw-bold">{formatDate(versements?.updated_at)}</span></p>
                                            <p className="f-17">Montant payé: <span className="text-uppercase fw-bold">{ versements?.four_type == 'ciment_de_guinee' || versements?.four_type == 'cimaf'  ? formatPrice( versements?.mt_update) : formatPrice( versements?.montant)}</span></p>
                                        </Col>
                                    ) : (
                                        <Col lg={6} className="text-end">
                                            {
                                                Number(versements?.is_antidate) === 1 ? (
                                                    <p className="f-17">Anti-Daté ?: <Badges color="light-info">Oui</Badges></p>
                                                ) : (
                                                    <p className="f-17">Status: <Badges color="light-success">Payé</Badges></p>
                                                )
                                            }
                                            <p className="f-17">No Paiement: <span className="text-uppercase fw-bold">{versements?.pv_num_paiement}</span></p>
                                            <p className="f-17">Date de paiement: <span className="text-uppercase fw-bold">{formatDate(versements?.pv_date_paiement)}</span></p>
                                            <p className="f-17">Montant a payer: <span className="text-uppercase fw-bold">{versements?.four_type == 'ciment_de_guinee' || versements?.four_type == 'cimaf' ? (formatPrice(versements?.mt_update)) : (formatPrice(versements?.pv_montant))}</span></p>
                                        </Col>
                                    )
                                }
                            </Row>

                            <div className="mx-3 mt-5">

                                {
                                    versements?.four_type == 'ciment_de_guinee' ? (
                                        <TableauShowLaffrage table={identifyMat} versements={versements} />
                                    ) : versements?.four_type == 'diamond' || versements?.four_type == 'diamond_sougueta' ? (
                                        <TableauShowDiamond versements={versements} />
                                    ) : versements?.four_type == 'cimaf' ? (
                                        <TableauShowCimaf versements={versements} />
                                    ) : (
                                        null
                                    )
                                }

                                <Row>
                                    <Col sm="5" className="mt-4" >

                                        <p className="f-17"> Enrégistré par : <span className="fw-bold">{versements?.users_name + " " + versements?.users_firstname}</span></p>
                                        {
                                            versements?.users_signature
                                                ? (<Image src={versements?.users_signature} alt="User signature" />)
                                                : (null)
                                        }
                                        <p className="f-17"> Téléphone : <span className="fw-bold">{formatPhoneNumber(versements?.users_phone)}</span></p>
                                    </Col>
                                    {show && (
                                        <Col sm="12" className="text-center mt-4">
                                            <Btn color="light-info" onClick={onPrint} className="btn btn-xs m-1 p-1 px-3">
                                                <i className="fa fa-print"></i> Imprimer
                                            </Btn>
                                            {versements?.justificatif && (
                                                <Btn color="light-info" onClick={() => downloadRecu(versements?.pv_id, versements?.justificatif)} className="btn btn-xs m-1 p-1 px-3">
                                                    <i className="fa fa-download"></i> Télécharger le justificatif valide
                                                </Btn>
                                            )}
                                            {versements?.status === 'Attente' && (versements?.four_type === 'cimaf' || versements?.four_type === 'ciment_de_guinee') && (
                                                (itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture')) && (
                                                    <>
                                                        <Btn color="light-success" onClick={() => openModalPaiement(versements?.id, versements?.mt_update)} className="btn btn-xs m-1 p-1 px-3">
                                                            <i className="fa fa-money"></i> Payer
                                                        </Btn>
                                                    </>
                                                )
                                            )}
                                            
                                            {versements?.qt_update !== 0 && versements?.mt_update !== versements?.montant && (
                                                (itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture') || itemHasPermission('gest. bons ecriture')) && (
                                                    <>
                                                        <Btn color="light-dark" onClick={openModalAddNumBons} disabled={versements?.four_type === 'ciment_de_guinee' && versements?.status === 'Payé'} className="btn btn-xs m-1 p-1 px-3 for-light">
                                                            <i className="fa fa-plus"></i> Ajouter N° de bons
                                                        </Btn>
                                                        <Btn color="light-light" onClick={openModalAddNumBons} disabled={versements?.four_type === 'ciment_de_guinee' && versements?.status === 'Payé'} className="btn btn-xs m-1 p-1 px-3 for-dark">
                                                            <i className="fa fa-plus"></i> Ajouter N° de bons
                                                        </Btn>
                                                    </>
                                                )
                                            )}
                                            {
                                                (versements?.four_type == 'cimaf') && (itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture')) && (
                                                    <Btn color="light-success" onClick={() => openModalAugmenterMontantForCimaf()} className="btn btn-xs m-1 p-1 px-3">
                                                        <i className="fa fa-money"></i> Augmenter le montant
                                                    </Btn>
                                                )
                                            }
                                            
                                            <Link to="/gestion-versements" className="btn btn-xs mx-1 p-1 px-3 btn-light-danger">
                                                <i className="fa fa-sign-out"></i> Quitter
                                            </Link>
                                        </Col>
                                    )}

                                </Row>
                             </div>
                            </div>
                        </CardBody>
                    </Card>

                    <Row>
                        <Col sm={3}>
                            <Card className="invoice-card">
                                <CardHeader className="pb-0">
                                    <H4 className="f-20 text-center"> Numéro des bons</H4>
                                    {/* <H4 className="f-30 text-center"><i className="icofont icofont-money f-40 text-success"></i> Bon de commande <i className="icofont icofont-money f-40 text-success"></i></H4> */}
                                </CardHeader>
                                <CardBody className="invoice-table pt-0 checkbox-checked">
                                    <Table responsive id="all-invoice">
                                        <thead className="bg-info">
                                            <tr>
                                                <th className="text-white">Numéro</th>
                                                <th className="text-white text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                            {bons && bons.length > 0 ? bons.map((item, index) => (
                                                <tr key={index}>
                                                    <td>#{item.num}</td>
                                                    <td className="text-center">
                                                        {
                                                            item.bons_id === null ? (
                                                                // <span className="text-danger">Aucun Bon disponible</span>
                                                                <Btn color="light-danger" onClick={() => Confirmation({id: item.id, fournisseur: '', action: 'supprimerNumBon'})} className="btn btn-xs mx-1 p-1 px-3">
                                                            <i className="fa fa-trash"></i>
                                                        </Btn>
                                                            ) : (
                                                                <>
                                                                    <Link className='btn bg-light-dark btn-xs mx-1 for-light' to={`/show-bon-de-commande/${item.bons_id}`}>
                                                                        <i className='fa fa-eye'></i>
                                                                    </Link>
                                                                    <Link className='btn btn-light-light btn-xs mx-1 for-dark' to={`/show-bon-de-commande/${item.bons_id}`}>
                                                                        <i className='fa fa-eye'></i>
                                                                    </Link>
                                                                </>
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">Aucun paiement trouvé.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={9}>
                            <Card className="invoice-card">
                                <CardHeader className="pb-0">
                                    <H4 className="f-30 text-center"><i className="icofont icofont-money f-40 text-success"></i> Details Paiements <i className="icofont icofont-money f-40 text-success"></i></H4>
                                </CardHeader>
                                <CardBody className="invoice-table pt-0 checkbox-checked">
                                    <Table responsive id="all-invoice">
                                        <thead className="bg-info">
                                            <tr>
                                                <th className="text-white text-center">No Paiement</th>
                                                <th className="text-white">Montant</th>
                                                <th className="text-white text-center">Date de paiement</th>
                                                <th className="text-white text-center">Anti-Date?</th>
                                                <th className="text-white text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paiements && paiements.length > 0 ? paiements.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">#{item.num_paiement}</td>
                                                    <td>
                                                        {
                                                            item.status === 'Invalide' ? (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="flex-shrink-0">
                                                                        <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <Link to="#">
                                                                            <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                        </Link>
                                                                        <span className="text-success text-capitalize f-w-400 f-13">  Paiement Effectué </span>
                                                                    </div>
                                                                </div>
                                                            ) : versements?.status === 'Payé' && item.status === 'Valide' ? (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="flex-shrink-0">
                                                                        <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <Link to="#">
                                                                            <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                        </Link>
                                                                        <span className="text-success text-capitalize f-w-400 f-13">  Paiement Effectué </span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="flex-shrink-0">
                                                                        <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <Link to="#">
                                                                            <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                        </Link>
                                                                        <span className="font-light text-capitalize f-w-400 f-13"> {calculateDaysRemaining(item.date_paiement)} Jours restant </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="text-capitalize">{formatDate(item.date_paiement)}</span><br />
                                                        {
                                                            item.status === 'Invalide' ? (
                                                                <span className="text-success text-capitalize f-w-400 f-13">  {formatDate(item.updated_at)} </span>
                                                            ) : versements?.status === 'Payé' && item.status === 'Valide' ? (
                                                                <span className="text-success text-capitalize f-w-400 f-13">  {formatDate(item.updated_at)} </span>
                                                            ) : (
                                                                null
                                                            )
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                        {
                                                            Number(item.is_antidate) === 1 ? (
                                                                <span className="fw-bold text-info">OUI</span>
                                                            ) : (
                                                                <>
                                                                    <Btn className={`btn btn-xs mx-1 p-1 for-dark`} color={`light-light`}>NON</Btn>
                                                                    <Btn className={`btn btn-xs mx-1 p-1 for-light`} color={`light-dark`}>NON</Btn>

                                                                </>
                                                            )
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                        {
                                                            item.justificatif == '' || item.justificatif == null ? (
                                                               <>
                                                                 <span>Aucun Justificatif</span>
                                                               </>
                                                            ) : (
                                                                <>
                                                                    <Btn color="light-info " onClick={() => downloadRecu(item.id, versements?.justificatif)} className="btn btn-xs mx-1 p-1 px-3">
                                                                        <i className="fa fa-download"></i> Télécharger
                                                                    </Btn>
                                                                </>
                                                               
                                                            )
                                                        }

                                                        {
                                                            versements?.four_type === 'diamond' || versements?.four_type === 'diamond_sougueta' ? (
                                                                (itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture')) && (
                                                                    Number(item.is_push) === 0 && item.status === 'Valide' && versements?.status === 'Attente' ? (
                                                                        <>
                                                                            <Btn className={`btn btn-xs m-1 p-1 px-3 for-dark`} color={`light-light`} onClick={() => openModalWithRow(item.id)} >Repousser</Btn>
                                                                            <Btn className={`btn btn-xs m-1 p-1 px-3 for-light`} color={`light-dark`} onClick={() => openModalWithRow(item.id)} >Repousser</Btn>
                                                                            <Btn color="light-success" onClick={() => openModalPaiement(versements?.id, item?.montant)} className="btn btn-xs mx-1 p-1 px-3">
                                                                                <i className="fa fa-money"></i> Payer
                                                                            </Btn>
                                                                        </>
                                                                    ) : Number(item.is_push) === 1 && item.status === "Invalide" && versements?.status === 'Attente' ? (
                                                                      <>
                                                                        <Btn className={`btn btn-xs m-1 p-1 px-3`} color={`light-warning`}>Paiement repousser</Btn>
                                                                        <Btn color="light-danger " onClick={() => Confirmation({id: item.id, fournisseur: versements?.four_type, action: 'supprimerPaiement'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                            <i className="fa fa-trash"></i>
                                                                        </Btn>
                                                                      </>
                                                                    ) : (
                                                                        null
                                                                    )
                                                                )
                                                            ) : (
                                                                null
                                                            )
                                                        }
                                                        {
                                                            versements?.four_type === 'ciment_de_guinee' && Number(item.is_antidate) === 0 && (
                                                                <Btn color="light-danger " onClick={() => Confirmation({id: item.id, fournisseur: versements?.four_type, action: 'supprimerPaiement'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                    <i className="fa fa-trash"></i>
                                                                </Btn>
                                                            )
                                                        }

                                                        {
                                                            (versements?.four_type === 'diamond' || versements?.four_type === 'diamond_sougueta') && versements?.status === 'Payé' && (
                                                                <Btn color="light-danger " onClick={() => Confirmation({id: item.id, fournisseur: versements?.four_type, action: 'supprimerPaiement'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                    <i className="fa fa-trash"></i>
                                                                </Btn>
                                                            )
                                                        }

                                                        {
                                                            versements?.four_type === 'cimaf' && Number(item.is_antidate) === 0 && (
                                                                <Btn color="light-danger " onClick={() => Confirmation({id: item.id, fournisseur: versements?.four_type, action: 'supprimerPaiement'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                    <i className="fa fa-trash"></i>
                                                                </Btn>
                                                            )
                                                        }

                                                        {
                                                            versements?.four_type === 'cimaf' && Number(item.is_add) === 1 && (
                                                                <>
                                                                    <br /><span className="text-success">Montant Augmenter</span>
                                                                </>
                                                            )
                                                        }
                                                         
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">Aucun paiement trouvé.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
            </Container>
            {
                repousserPaiement({
                    isOpen: staticModal,
                    paiement_id: paiementId ?? 0,
                    versement_id: params.id ? parseInt(params.id) : 0,
                    toggle: staticModalToggle,

                }, () => setRefresh(!refresh))
            }{
                AddNumBons({
                    isOpen: modalAdd,
                    versement_id: versements?.id ? versements?.id : 0,
                    fournisseur_id: versements?.four_id,
                    four_type: versements?.four_type,
                    toggle: staticModalAddNumBonToggle,
                }, () => setRefresh(!refresh))
            }{
                PayerVersement({
                    isOpen: modalPaiement,
                    montant_a_payer: montantPayed ?? 0,
                    versement_id: versements?.id ?? 0,
                    toggle: staticModalPaiementToggle,
                }, () => setRefresh(!refresh))
            }
            <AugmenterLeMontantPourCimaf
                isOpen={modalAugmentMontantForCimaf}
                versement_id={versements?.id ?? 0}
                toggle={staticModalAugmenterMontantForCimafToggle}
                onSuccess={() => setRefresh(!refresh)}
            />
        </div >

    )
}

export default ShowVersementsV2;